import React, { useState } from "react";
import { httpGet } from "../../helpers/httpHelper";


const BiTooltip = (props) => {
    let timeout;
    const [active, setActive] = useState(false);
    const [cont, setCont] = useState("");
    const [smer, setSmer] = useState("bottom");
    const showTip = (e) => {

        var cX = e.clientX;
        var cY = e.clientY;

        var sW = window.innerWidth;
        var sH = window.innerHeight;

        let ss = "right";
        if (sW - cX < 200) {
            ss = "bottom";
        }
        if (cY < 150) {
            ss = "bottom";
        }

        setSmer(ss);

        console.log(cX, cY, sW, sH);

        timeout = setTimeout(() => {

            if (cont == "") {
                setCont("...");
                
                httpGet("etm/getMoHelp", { key: props.helpKey() }, (data) => {
                    if (data.data != null) {
                        setCont(data.data.opis);
                        setActive(true);
                    } else {
                        setCont("");
                    }
                });
            } else {
                setCont(cont);
                setActive(true);
            }
            
        }, props.delay || 400);
    };

    const hideTip = () => {
        clearInterval(timeout);
        setActive(false);
    };

    return (
        <div
            className="Tooltip-Wrapper"
            // When to show the tooltip
            onMouseEnter={showTip}
            onMouseLeave={hideTip}
        >
            {/* Wrapping */}
            {props.children}
            {active && (
                <div className={"Tooltip-Tip "+smer}>
                    {/* Content */}
                    <div dangerouslySetInnerHTML={{ __html: cont }} />
                </div>
            )}
        </div>
    );
};

export default BiTooltip;
